{
  "Sidebar": {
    "badges": {
      "beta": "Beta"
    },
    "guest": {
      "title": "Guarda tu trabajo",
      "description": "Regístrate gratis para guardar permanentemente tus exámenes, chats y configuraciones.",
      "loginButton": "Iniciar sesión ahora"
    },
    "actions": {
      "newExamTitle": "Crear nuevo examen",
      "creating": "Creando...",
      "newExam": "Nuevo examen"
    },
    "examList": {
      "title": "Mis exámenes",
      "noExams": "No se encontraron exámenes.",
      "unnamed": "Sin título",
      "unnamedExam": "Examen sin título",
      "loadOlder": "Cargar exámenes anteriores"
    },
    "examMenu": {
      "edit": "Editar",
      "addToClass": "Añadir a la clase",
      "delete": "Eliminar"
    },
    "bottomNav": {
      "profile": "Perfil",
      "settings": "Configuración",
      "feedback": "Dar opinión"
    },
    "dialogs": {
      "renameTitle": "Editar examen",
      "groupTitle": "Agrupar examen",
      "renameDesc": "Edita la información de este examen.",
      "groupDesc": "Selecciona una clase o grupo para este examen.",
      "fields": {
        "name": "Nombre",
        "subject": "Asignatura",
        "topic": "Tema",
        "class": "Clase",
        "placeholderSelect": "Por favor, selecciona..."
      },
      "save": "Guardar"
    },
    "alerts": {
      "deleteConfirm": "¿Estás seguro de que quieres eliminar este examen?",
      "saveFailed": "Error al guardar"
    }
  },
  "Settings": {
    "title": "Configuración",
    "soon": "Próximamente",
    "DisplayAndLanguage": {
      "title": "Pantalla e Idioma",
      "languageLabel": "Idioma",
      "languageDesc": "Elige el idioma de la interfaz.",
      "themeLabel": "Apariencia",
      "themeDesc": "Cambia entre el modo claro y oscuro."
    },
    "AI": {
      "title": "IA y Calificación",
      "strictnessLabel": "Incertidumbre de la IA",
      "strictnessDesc": "Determina en qué nivel de confianza de la IA es obligatoria la revisión manual.",
      "strictnessWarning": "Advertencia: Con \"Alta autonomía\", solo interviene manualmente cuando la IA tiene mucha incertidumbre...",
      "gradingKindnessLabel": "Rigor de Calificación",
      "gradingKindnessDesc": "Determina con qué rigor aplica la IA el esquema de calificación. Indulgente favorece al estudiante en casos límite; Estricto sigue el esquema exactamente.",
      "gradingKindnessOptions": {
        "lenient": "Indulgente",
        "balanced": "Equilibrado",
        "strict": "Estricto"
      }
    },
    "Notifications": {
      "title": "Notificaciones",
      "soon": "Próximamente",
      "emailLabel": "Notificaciones por correo electrónico",
      "emailDesc": "Recibe notificaciones por correo sobre eventos importantes.",
      "browserLabel": "Notificaciones del navegador",
      "browserDesc": "Recibe notificaciones push directamente en tu navegador."
    },
    "About": {
      "title": "Acerca de Gradias",
      "landingPage": "Visitar gradias.ai",
      "support": "Ayuda y Soporte",
      "imprint": "Aviso legal",
      "privacy": "Política de privacidad"
    },
    "Account": {
      "title": "Datos y Cuenta",
      "exportLabel": "Exportar mis datos",
      "exportDesc": "Descarga todos los exámenes subidos y los resultados en un archivo ZIP.",
      "deleteLabel": "Eliminar mi cuenta",
      "deleteDesc": "Elimina permanentemente tu cuenta y todos los datos asociados."
    }
  },
  "Profile": {
    "title": "Perfil",
    "actions": {
      "cancel": "Cancelar",
      "save": "Guardar",
      "edit": "Editar"
    },
    "alerts": {
      "saveError": "No se pudo guardar el perfil.",
      "generalError": "Ocurrió un error."
    },
    "personal": {
      "firstName": "Nombre",
      "lastName": "Apellidos",
      "name": "Nombre",
      "school": "Escuela",
      "noSchool": "No se especificó ninguna escuela",
      "email": "Correo electrónico",
      "emailHint": "El correo electrónico no se puede cambiar aquí.",
      "defaultUser": "Usuario",
      "role": {
        "teacher": "Profesor/a",
        "student": "Estudiante"
      }
    },
    "teaching": {
      "subjects": "Mis Asignaturas"
    },
    "rules": {
      "title": "Reglas y preferencias",
      "description": "Preferencias guardadas que el asistente sigue: al chatear, calificar y crear soluciones modelo y esquemas de calificación. Puedes editarlas aquí tú mismo, pero el asistente también puede ajustarlas por ti directamente en el chat.",
      "general": "General",
      "empty": "Aún no hay reglas guardadas.",
      "addRule": "Añadir regla",
      "removeRule": "Eliminar regla",
      "limitReached": "Límite alcanzado",
      "limitHint": "Máximo {{max}} reglas por categoría",
      "placeholder": "Describe una regla …",
      "categories": {
        "chat_and_workflow": "Chat y flujo de trabajo",
        "grading_and_feedback": "Calificación y comentarios",
        "master_solution_design": "Soluciones modelo",
        "grading_scheme_creation": "Esquemas de calificación"
      },
      "categoryDescs": {
        "chat_and_workflow": "Cómo responde el asistente en el chat y gestiona el flujo de trabajo",
        "grading_and_feedback": "Cómo se califican las respuestas y se redactan los comentarios",
        "master_solution_design": "Cómo se crean las soluciones modelo",
        "grading_scheme_creation": "Cómo se elaboran los esquemas de calificación"
      },
      "grammar": {
        "alwaysUseFi": "Usar siempre el índice de errores (FI)",
        "alwaysUseFiDesc": "Usa por defecto el índice de errores en lugar de cualquier regla de gramática detectada en un esquema de calificación subido. Se puede anular por examen.",
        "languageUseRegradeWordCutoff": "Recalificar automáticamente la expresión escrita a partir de (palabras)",
        "languageUseRegradeWordCutoffDesc": "Al editar la respuesta de un alumno, la expresión escrita del grupo afectado se recalifica automáticamente en cuanto se han cambiado al menos esta cantidad de palabras (varias ediciones pequeñas se suman).",
        "contentRegradeWordCutoff": "Recalificar automáticamente el contenido a partir de (palabras)",
        "contentRegradeWordCutoffDesc": "0 = siempre (por defecto): el contenido se recalifica de inmediato con cualquier cambio de texto. Un valor más alto omite la recalificación automática en cambios muy pequeños."
      }
    },
    "security": {
      "title": "Cuenta y Seguridad",
      "changePassword": "Cambiar contraseña",
      "changePasswordDesc": "Gestiona la seguridad de tu cuenta",
      "logout": "Cerrar sesión",
      "logoutDesc": "Cierra sesión de forma segura en este dispositivo"
    },
    "badges": {
      "soon": "Próximamente"
    }
  },
  "ClassInsights": {
    "overview": "Resumen",
    "examCount": "Exámenes",
    "subjectCount": "Asignaturas",
    "gradedCount": "Corregidos",
    "examListTitle": "Exámenes de esta clase",
    "noExams": "Aún no hay exámenes en esta clase.",
    "loading": "Cargando estadísticas …",
    "statusGraded": "Corregido",
    "statusInProgress": "En progreso",
    "unnamedExam": "Examen sin nombre",
    "unknownSubject": "Asignatura desconocida"
  },
  "Dashboard": {
    "guestMessage": "Soy gradi, tu asistente de IA para corregir exámenes.",
    "greetings": {
      "opt1": "¿Qué exámenes vamos a corregir hoy?",
      "opt2": "Vamos a encargarnos de tu pila de exámenes.",
      "opt3": "¿Qué hay en la agenda de hoy?",
      "opt4": "¿En qué te puedo ayudar hoy?",
      "opt5": "Qué bueno verte. ¿Por dónde empezamos?",
      "opt6": "¡A corregir!"
    },
    "fallbackGreeting": "¿Qué hay en la agenda de hoy?",
    "greetingPrefix": "Hola",
    "inputPlaceholder": "Haz una pregunta...",
    "dropzoneText": "Suelta los archivos aquí",
    "actions": {
      "startGrading": {
        "label": "Comenzar corrección de examen",
        "prompt": "Quiero comenzar a corregir un nuevo examen. Por favor, guíame paso a paso a través del proceso, desde la subida de archivos hasta el esquema de calificación."
      },
      "howItWorks": {
        "label": "¿Cómo funciona gradias?",
        "prompt": "Por favor, explica brevemente cómo funciona gradias y qué pasos debo seguir para una corrección exitosa."
      },
      "sampleData": {
        "label": "Probar con datos de ejemplo",
        "prompt": "Quiero probar el sistema pero no tengo mis propios exámenes a mano. ¿Cómo puedo hacer una prueba con un examen de muestra?"
      },
      "taskTypes": {
        "label": "¿Qué tipos de tareas existen?",
        "prompt": "¿Qué tipos de tareas (por ejemplo, texto libre, opción múltiple, ecuaciones matemáticas) puedes corregir actualmente?"
      },
      "privacy": {
        "label": "Privacidad y Seguridad de Datos",
        "prompt": "¿Cómo maneja gradias la privacidad de los datos? ¿Qué pasa con los exámenes subidos de mis estudiantes?"
      }
    },
    "alerts": {
      "uploadError": "Error al subir el archivo",
      "noExamId": "No hay examId presente"
    },
    "aria": {
      "uploadFiles": "Subir archivos",
      "submit": "Enviar",
      "removeFile": "Eliminar archivo adjunto"
    }
  },
  "ChatInput": {
    "statusLabels": {
      "allComplete": "Todos los pasos completados",
      "configRunning": "Terminado - Listo para continuar",
      "readyForConfig": "Listo para configurar",
      "status": "Estado",
      "progress": "Progreso",
      "inProgress": "en curso"
    },
    "steps": {
      "examCreator": {
        "label": "Crear examen",
        "phasePlan": "Planificando el examen",
        "phaseMaterial": "Generando figuras",
        "phaseSource": "Redactando las tareas",
        "phaseRepair": "Finalizando el documento"
      },
      "upload": {
        "label": "Subida de archivos"
      },
      "studentAssignment": {
        "label": "Asignación de estudiantes",
        "activeWait": "Esperando confirmación",
        "activeAssign": "Asignar entregas de estudiantes"
      },
      "structure": {
        "label": "Estructura del examen",
        "active": "Detectando tareas"
      },
      "answers": {
        "label": "Respuestas de estudiantes",
        "active": "Procesando respuestas"
      },
      "masterSolution": {
        "label": "Solución modelo",
        "activeDetect": "Detectando solución modelo",
        "activeCreate": "Creando solución modelo",
        "activeComplete": "Completando la solución modelo"
      },
      "gradingScheme": {
        "label": "Esquema de calificación",
        "activeDetect": "Detectando criterios de calificación",
        "activeCreate": "Creando criterios de calificación",
        "activeComplete": "Completando los criterios de evaluación"
      },
      "grading": {
        "label": "Corrección",
        "active": "Corrección en curso"
      },
      "summary": {
        "label": "Resumen de resultados"
      }
    },
    "badges": {
      "uncertainties": "Incertidumbres",
      "errorRegions": "Zonas de error",
      "errorSubmissions": "Entregas con error",
      "documentEncrypted": "Documento encriptado"
    },
    "ui": {
      "showProgress": "Mostrar progreso de corrección",
      "dropFilesHere": "Suelta los archivos aquí",
      "uploadFiles": "Subir archivos",
      "waitUpload": "Esperando subida",
      "sendMessage": "Enviar mensaje",
      "privacyNotice": "100% compatible con GDPR. Tus datos y los documentos de los estudiantes no se utilizan para entrenar a la IA.",
      "learnMore": "Saber más."
    },
    "alerts": {
      "uploadError": "Error al subir el archivo",
      "noExamId": "No hay examId presente"
    }
  },
  "TokenInput": {
    "placeholder": "Haz una pregunta..."
  },
  "Chat": {
    "auth": {
      "login": "Iniciar sesión",
      "register": "Registrarse"
    },
    "loading": {
      "masterSolutions": "Cargando soluciones modelo...",
      "examData": "Cargando datos del examen e imágenes...",
      "extractingTasks": "Extrayendo tareas... {{finished}}/{{total}}",
      "splitThinkingMessage": "Asigno los trabajos de los alumnos",
      "structureThinkingMessage": "Detecto la estructura del examen",
      "examStructure": "Cargando estructura del examen...",
      "pages": "Cargando páginas...",
      "summary": "Cargando resumen..."
    },
    "alerts": {
      "errorOccurred": "Lo siento, ocurrió un error. Por favor, inténtalo de nuevo más tarde.",
      "reportsBlocked": "Los informes en PDF solo están disponibles cuando todas las tareas principales han sido aprobadas o tienen una confianza de IA superior al {{threshold}}%.",
      "noSubmissionsForReports": "No se encontraron entregas con datos para el informe.",
      "reportsFailed": "No se pudieron generar los informes en PDF. Por favor, inténtalo de nuevo."
    },
    "sampleExamIntro": "Me gustaría corregir este examen con los siguientes documentos:\n{{lines}}",
    "canvasTitles": {
      "boundingbox": "Ajustar cuadros delimitadores",
      "msedit": "Editar solución modelo y esquema de calificación",
      "correction": "Corrección",
      "summary": "Resumen de calificación",
      "structureeditor": "Editar estructura del examen",
      "submissioncheck": "Verificar asignación de páginas",
      "demoselector": "Seleccionar demostración",
      "examcreator": "Crear examen",
      "default": "Vista detallada"
    }
  },
  "Canvas": {
    "common": {
      "resize": "Cambiar tamaño",
      "toSummaryTitle": "Ir al resumen",
      "backToSummary1": "Volver a",
      "backToSummary2": "resumen",
      "restore": "Restaurar",
      "fullscreen": "Pantalla completa",
      "close": "Cerrar"
    },
    "grading": {
      "prevTask": "Tarea anterior",
      "nextTask": "Siguiente tarea",
      "taskXofY": "Tarea {{current}} de {{total}}",
      "taskName": "Tarea {{number}}",
      "nextUncertainty": "Siguiente incertidumbre ({{count}})",
      "uncertaintiesLeft": "Quedan {{count}} incertidumbres",
      "backToSummary1": "Volver a",
      "backToSummary2": "resumen",
      "submissionX": "Entrega {{id}}",
      "pages": "Páginas:",
      "pageX": "Página {{page}}",
      "addBoundingBox": "Añadir nuevo cuadro delimitador",
      "extractedText": "Texto extraído",
      "verified": "Verificado",
      "consistencyAdjusted": "Ajustado automáticamente para mantener la coherencia con otras entregas",
      "bboxConfidence": "Confianza de cuadro: {{conf}}%",
      "review": "Revisar",
      "noTextExtracted": "No se extrajo texto.",
      "imageContent": "Imagen (sin reconocimiento de texto) - el recorte de imagen reconocido se utilizará directamente para el procesamiento posterior",
      "aiGrading": "Corrección por IA",
      "pts": "pts.",
      "points": "Puntos:",
      "noGradingYet": "Aún no hay calificación disponible.",
      "gradingScheme": "Esquema de calificación",
      "expand": "Expandir",
      "collapse": "Colapsar",
      "maxPoints": "Puntos máximos: {{points}}",
      "noGradingSchemeYet": "Aún no hay esquema de calificación disponible.",
      "boxModeContent": "Contenido",
      "boxModeLanguageUse": "Expresión escrita",
      "groupLanguageUseRule": "Grupo: tarea {{tasks}}",
      "groupLanguageUseRuleNumbered": "Grupo {{number}}: tarea {{tasks}}",
      "editLanguageUseGroupTasks": "Editar tareas de este grupo",
      "deleteLanguageUseGroup": "Eliminar esta regla de expresión escrita",
      "deleteLanguageUseGroupConfirm": "¿Eliminar esta regla de expresión escrita? Esta acción no se puede deshacer.",
      "deleteLanguageUseGroupBlocked": "No se puede eliminar mientras se está calificando.",
      "languageUseGroupPickerInfo": "Marca una tarea para añadirla a este grupo. Desmárcala para quitarla; si aún necesita su propia regla de expresión escrita, se rellena con el texto de este grupo y 0 puntos para que puedas encontrarla de nuevo.",
      "languageUseGroupPickerSaveFailed": "Error al guardar. Inténtalo de nuevo.",
      "languageUseGroupPickerEmptyDraft": "Una regla necesita al menos una tarea.",
      "deleteBox": "Eliminar cuadro delimitador",
      "retryOcr": "Reintentar reconocimiento de texto",
      "unlockBox": "Desbloquear cuadro delimitador",
      "lockBox": "Bloquear cuadro delimitador",
      "noSubmissionsFound": "No se encontraron entregas.",
      "examPageX": "Página del examen {{page}}",
      "modeCorrection": "Corrección",
      "modeGrammar": "Gramática",
      "grammarTitle": "Ortografía y Gramática",
      "grammarErrors": "Errores",
      "fehlerindex": "Índice de errores",
      "words": "Palabras",
      "noGrammarErrors": "No se encontraron errores.",
      "noGrammarEvaluationForTask": "No hay evaluación gramatical para esta tarea.",
      "notLocated": "No localizado en la imagen",
      "notLocatedShort": "sin marcador",
      "deleteGrammarError": "Eliminar error",
      "editGrammarError": "Editar error",
      "saveGrammarError": "Guardar",
      "addMistake": "Añadir error",
      "mistakePlaceholder": "Descripción del error…",
      "errorCategories": {
        "TYPOS": "Erratas",
        "GRAMMAR": "Gramática",
        "SEMANTICS": "Semántica",
        "STYLE": "Estilo",
        "PUNCTUATION": "Puntuación",
        "TYPOGRAPHY": "Tipografía",
        "REDUNDANCY": "Redundancia",
        "CASING": "Mayúsculas",
        "COLLOCATIONS": "Colocaciones",
        "CONFUSED_WORDS": "Confusión de palabras",
        "FALSE_FRIENDS": "Falsos amigos",
        "GENDER_NEUTRALITY": "Neutralidad de género",
        "IDIOMS": "Modismos",
        "MISC": "Varios",
        "NONSTANDARD_PHRASES": "Frases no estándar",
        "PLAIN_ENGLISH": "Lenguaje sencillo",
        "PROPER_NOUNS": "Nombres propios",
        "REGIONALISMS": "Regionalismos"
      },
      "rerunningOcr": "Repitiendo el reconocimiento de texto...",
      "regrading": "Recalificando...",
      "regradingQueued": "En cola..."
    },
    "msgs": {
      "noTasksFound": "No se encontraron tareas.",
      "prevTask": "Tarea anterior",
      "nextTask": "Siguiente tarea",
      "task": "Tarea",
      "taskMain": "Tarea {{main}}",
      "taskSub": "Tarea {{main}}.{{sub}}",
      "uncertaintiesLeft": "Quedan {{count}} incertidumbres",
      "nextUncertainty": "Siguiente incertidumbre ({{count}})",
      "taskExcerpt": "Fragmento de la tarea",
      "noImageAvailable": "No hay imagen disponible...",
      "masterSolution": "Solución modelo",
      "aiGeneratedProposalTooltip": "Propuesta generada por IA",
      "aiGeneratedProposal": "Propuesta generada por IA",
      "review": "Revisar",
      "approvalRequiresPoints": "La aprobación no es posible mientras la puntuación sea 0.",
      "saveRequiresPoints": "Guardar no es posible mientras la puntuación sea 0.",
      "enterMasterSolution": "Introduce la solución modelo aquí...",
      "noMasterSolutionYet": "Aún no hay solución modelo disponible...",
      "gradingScheme": "Esquema de calificación",
      "maxPoints": "Puntos máximos",
      "maxPointsValue": "Puntos máximos: {{points}}",
      "enterGradingScheme": "Introduce el esquema de calificación aquí...",
      "noGradingSchemeYet": "Aún no hay esquema de calificación disponible...",
      "gradingSchemeRefining": "Actualizando los criterios de calificación...",
      "masterSolutionRefining": "Actualizando la solución modelo..."
    },
    "submissionCheck": {
      "pageShort": "P. {{page}}",
      "zoomPage": "Ampliar página {{page}}",
      "pageAlt": "Página",
      "loading": "Cargando...",
      "newStudent": "Nuevo estudiante",
      "readOnly": "Solo lectura",
      "saveAssignment": "Guardar asignación",
      "unassignedPagesTitle": "Requiere aclaración: Páginas sin asignar ({{count}})",
      "unassignedPagesHint": "Por favor, arrastra estas páginas a las carpetas de los estudiantes.",
      "newStudentIndexed": "Nuevo estudiante {{index}}",
      "studentIndexed": "Estudiante {{index}}",
      "enterName": "Introduce nombre...",
      "pageX_one": "{{count}} página",
      "pageX_other": "{{count}} páginas",
      "splitConfidenceHover": "Confianza de división: {{percent}}%",
      "splitPercent": "División {{percent}}%",
      "deleteStudent": "Eliminar estudiante",
      "dragHint": "Arrastra los documentos aquí para asignarlos a {{name}}",
      "assignmentNotes": "Notas de asignación",
      "previewPageAlt": "Vista previa de la página {{page}}",
      "pageCurrentOfTotal": "Página {{current}} de {{total}}",
      "locked": "Confirmado",
      "lockedHint": "Ya confirmado: ya no se puede editar."
    },
    "summary": {
      "studentsOverview": "Resumen de estudiantes",
      "studentsOverviewDesc": "Puntos detallados y evaluación de la IA por tarea",
      "searchStudent": "Buscar nombre de estudiante...",
      "student": "Estudiante",
      "pointsAbbr": "pts.",
      "total": "Total",
      "percentage": "Porcentaje",
      "grade": "Nota",
      "noHits": "Sin resultados.",
      "aiConfidenceHover": "Confianza de IA: {{percent}}% - Por favor, revisa manualmente",
      "aiUncertainties": "Incertidumbres de IA",
      "aiUncertaintiesDesc": "Revisa los casos donde la IA tenga dudas para asegurar una corrección justa.",
      "openDecisions": "{{count}} decisiones pendientes",
      "sortBy": "Ordenar por",
      "task": "Tarea",
      "aiUncertainty": "Incertidumbre de IA",
      "confidence": "Confianza de IA:",
      "points": "Puntos:",
      "toGrading": "Ir a corrección",
      "confirmed": "Confirmado",
      "confirm": "Confirmar",
      "noClarificationNeeded": "No requiere aclaración.",
      "worstAvg": "Promedio más bajo",
      "noDataYet": "Aún no hay datos",
      "avgSuffix": "de media",
      "frequentErrors": "Fuentes de error más frecuentes",
      "metricsPerTask": "Métricas por tarea",
      "gradeDistribution": "Distribución de notas",
      "count": "Cantidad",
      "pdfReports": "Informes PDF",
      "downloadingPdf": "Generando informes en PDF...",
      "downloadPdf": "Descargar informes en PDF",
      "csvExport": "Exportación de Notas CSV",
      "notConnected": "Aún no conectado",
      "notMet": "No cumplido",
      "downloadingCsv": "Generando CSV...",
      "downloadCsv": "Descargar CSV",
      "gradeScale": "Escala de calificación",
      "gradeFrom": "Nota {{grade}} desde",
      "normalDistribution": "Distribución normal (Campana de Gauss)",
      "activated": "Activado",
      "deactivated": "Desactivado",
      "curveStrength": "Fuerza de la curva",
      "curvingComingSoon": "El ajuste de curva aún no está disponible. Esta función llegará próximamente.",
      "noSubmissionsFound": "No se encontraron entregas corregidas.",
      "avgPointsReached": "Ø Puntos logrados",
      "pointsReached": "Puntos logrados",
      "gradeSystem": "Sistema de calificación",
      "gradeBorders": "Límites de notas",
      "lowestGradeLabel": "Nota más baja (a partir de 0%)",
      "tabs": {
        "students": "Resumen de alumnos",
        "clarification": "Necesita aclaración",
        "insights": "Perspectivas de tareas",
        "grades": "Distribución de notas",
        "curving": "Clave de calificación y curva",
        "export": "Exportar",
        "languageUse": "Expresión escrita & Gramática"
      },
      "gradingScales": {
        "german16": "Alemán (1–6)",
        "drittel": "Tercios (1.0–5.0)",
        "af": "A–F",
        "gpa4": "4.0 GPA",
        "notenpunkte": "Puntos de nota (0–15)",
        "numeric10": "10 puntos",
        "percentage": "Porcentaje",
        "custom": "Personalizado"
      },
      "grammar": "Gramática",
      "fehlerindex": "Índice de errores (FI)",
      "grammarFiColumnHint": "Incluye solo las tareas que aún se califican mediante el índice de errores; las tareas calificadas por reglas tienen sus propias columnas.",
      "taskLanguageUseColumn": "{{label}} · Expresión escrita",
      "grammarTab": {
        "noGrammarTasks": "Este examen no contiene tareas con evaluación gramatical.",
        "fiTitle": "Deducción por índice de errores",
        "fiDesc": "Índice de errores = errores por cada 100 palabras. Superar los umbrales reduce la nota final en pasos de nota.",
        "fiUnsupportedScale": "No es posible deducir pasos de nota con una escala porcentual.",
        "fiAbove": "Si el índice de errores supera",
        "deductSteps": "deducir (pasos de nota)",
        "matrixTitle": "Errores gramaticales por estudiante y tarea",
        "matrixDesc": "Número de errores (índice de errores entre paréntesis). Al hacer clic en una celda se abre la corrección en modo gramática.",
        "fiSwitchTitle": "Aplicar índice de errores para este examen",
        "fiSwitchDesc": "Por defecto usa tu ajuste de perfil; actívalo para anularlo solo en este examen.",
        "gradeWithFi": "Nota (con IE)"
      },
      "languageUseTab": {
        "rulesOverviewTitle": "Reglas de expresión escrita utilizadas en la calificación",
        "ownRuleEntry": "{{label}}: regla propia ({{points}} pts)",
        "groupRuleEntry": "{{label}} ({{points}} pts)",
        "teacherRulesActive": "La expresión escrita se evalúa directamente durante la corrección según tus reglas personales. La deducción por índice de errores está desactivada."
      }
    },
    "demoSelector": {
      "title": "Seleccionar demostración",
      "description": "Prueba la carga con exámenes de ejemplo y explora las funcionalidades.",
      "examCount_one": "{{count}} examen",
      "examCount_other": "{{count}} exámenes",
      "studentCount_one": "{{count}} alumno",
      "studentCount_other": "{{count}} alumnos",
      "examLanguage": "Idioma del examen",
      "subjects": {
        "math": "Matemáticas",
        "english": "Inglés",
        "technical": "Técnico",
        "biology": "Biología",
        "spanish": "Español",
        "french": "Francés",
        "physics": "Física",
        "political_education": "Educación política",
        "german": "Alemán"
      },
      "roles": {
        "submission": "Entrega",
        "masterSolution": "Solución modelo",
        "gradingScheme": "Esquema de calificación",
        "blankExam": "Examen en blanco"
      },
      "grades": {
        "gesamtschule": "Escuela integral",
        "highSchool": "Instituto",
        "elementarySchool": "Escuela primaria",
        "vocationalSchool": "Escuela profesional / Educación para adultos",
        "middleSchool": "Escuela secundaria",
        "primarySchool": "Escuela primaria"
      },
      "exams": {
        "kaarst": {
          "name": "Prueba Kaarst (Matemáticas)",
          "description": "Examen de matemáticas con preguntas de cálculo y álgebra para práctica."
        },
        "arne": {
          "name": "Arne — Inglés",
          "description": "Examen de vocabulario y comprensión en inglés."
        },
        "lynehamMath": {
          "name": "Lyneham — Matemáticas",
          "description": "Ejemplo de examen centrado en funciones y geometría."
        },
        "tuevBauleiter": {
          "name": "Bauleiter (Certificación)",
          "description": "Preguntas de evaluación para la certificación de jefes de obra."
        },
        "tuvPhotovoltaik": {
          "name": "Fotovoltaica",
          "description": "Examen técnico sobre principios y normativa de sistemas fotovoltaicos."
        },
        "engVocabulary": {
          "name": "Inglés — Vocabulario",
          "description": "Ejercicio de vocabulario y comprensión en inglés."
        },
        "bioImageLabeling": {
          "name": "Biología — Etiquetado de imágenes",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        },
        "mathProofFr": {
          "name": "Prueba matemática",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        },
        "mathProofEng": {
          "name": "Prueba matemática",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        },
        "dictationEs": {
          "name": "Dictado — Español",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        },
        "dictationFr": {
          "name": "Dictado — Francés",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        },
        "plotting": {
          "name": "Dibujo de gráficas",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        },
        "curveAnalysis": {
          "name": "Análisis de funciones",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        },
        "calculationDe": {
          "name": "Física",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        },
        "calculationFr": {
          "name": "Cálculo",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        },
        "calculationEs": {
          "name": "Cálculo",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        },
        "calculationEn": {
          "name": "Cálculo",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        },
        "multipleChoiceDe": {
          "name": "Opción múltiple",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        },
        "multipleChoiceEn": {
          "name": "Opción múltiple",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        },
        "multipleChoiceFr": {
          "name": "Opción múltiple",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        },
        "multipleChoiceEs": {
          "name": "Opción múltiple",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        },
        "politics12German": {
          "name": "Educación política — 12º curso",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        },
        "poetry12German": {
          "name": "Análisis de poesía — 12º curso",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        },
        "poetry12English": {
          "name": "Análisis de poesía — 12º curso",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        },
        "poetry12French": {
          "name": "Análisis de poesía — 12º curso",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        },
        "materialBasedEnglish": {
          "name": "Ensayo basado en materiales",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        },
        "materialBasedGerman": {
          "name": "Ensayo basado en materiales",
          "description": "Conjunto completo: entregas de estudiantes, solución modelo, esquema de calificación y examen en blanco"
        }
      }
    },
    "structureEditor": {
      "pointsInconsistent": "Los puntos no cuadran. En cada nivel, asigna puntos a todas las tareas (que sumen el total de la tarea superior) o déjalas todas vacías. Corrige las tareas resaltadas:",
      "pointsInconsistentTask": "A la tarea {{path}} le faltan puntos",
      "totalPoints": "Puntos totales (incl. subtareas)",
      "ownPoints": "Puntos propios (la respuesta propia de esta tarea)",
      "tasksWithoutRegion": "Tareas sin región marcada",
      "noPages": "No hay páginas disponibles.",
      "taskAreasDetected_one": "{{count}} área de tarea detectada",
      "taskAreasDetected_other": "{{count}} áreas de tarea detectadas",
      "addArea": "Añadir área",
      "remove": "Eliminar",
      "resetZoom": "Restablecer zoom",
      "readOnly": "Solo lectura",
      "saving": "Guardando...",
      "saved": "Guardado",
      "blankExamPage": "Página en blanco del examen {{page}}",
      "deleteBbx": "Eliminar BBX",
      "retryOcr": "Reintentar reconocimiento de texto",
      "noTasksOnPage": "No hay tareas en esta página",
      "task": "Tarea",
      "noText": "Sin texto",
      "imageContent": "Imagen (sin reconocimiento de texto) - el recorte de imagen reconocido se utilizará directamente para el procesamiento posterior",
      "additionalInfo": "Información adicional",
      "noContent": "Sin contenido",
      "linkedTasks": "Tareas enlazadas",
      "noTasks": "Sin tareas"
    },
    "examEditor": {
      "savingAndRecompiling": "Guardando y recompilando…",
      "unsavedChanges": "Cambios sin guardar",
      "allChangesSaved": "Todos los cambios guardados",
      "readOnlyBanner": "Este examen está en modo de solo lectura: ya existe una solución modelo, un esquema de calificación o entregas de estudiantes basadas en la estructura de las tareas, por lo que ya no se pueden realizar cambios aquí.",
      "generatingExam": "Generando examen…",
      "refiningExam": "Actualizando examen…",
      "downloadPdf": "Descargar PDF",
      "preparingPdf": "Preparando PDF…",
      "notSaved": "No guardado: {{message}}",
      "seeProblemsBelow": "ver problemas abajo",
      "noExam": "Sin examen.",
      "noSourceYet": "Este examen aún no tiene fuente.",
      "noPreviewYet": "Aún no hay vista previa compilada — haz clic en cualquier bloque o punto para editar y generar una.",
      "tellAiPlaceholder": "Indica a la IA qué cambiar ...",
      "delete": "Eliminar",
      "applying": "Aplicando …",
      "send": "Enviar",
      "done": "Listo",
      "describeAiPlaceholder": "Describe a la IA qué tarea añadir aquí ...",
      "add": "Añadir",
      "adding": "Añadiendo …",
      "task": "Tarea {{number}}",
      "taskNumber": "Número de tarea",
      "type": "Tipo",
      "points": "Puntos",
      "lines": "Líneas",
      "taskText": "Texto de la tarea",
      "material": "Material",
      "title": "Título",
      "usedByTasks": "Usado por las tareas (números separados por comas)",
      "text": "Texto",
      "multipleChoice": "Opción múltiple",
      "removeOption": "Eliminar opción",
      "addOption": "+ Añadir opción",
      "figureProperties": "Propiedades de la figura",
      "caption": "Leyenda",
      "examSetup": "Configuración del examen",
      "subject": "Asignatura",
      "class": "Clase",
      "duration": "Duración",
      "totalPoints": "Puntuación total",
      "globalHints": "Indicaciones / instrucciones generales",
      "studentView": "Rellenar en línea"
    }
  },
  "TaskTypeDescs": {
    "taskFrame": "Agrupa subtareas, no requiere respuesta directa",
    "default": "Tipo general cuando ningún otro encaja",
    "shortText": "Respuesta escrita corta (pocas frases)",
    "essay": "Texto largo y estructurado, p.ej. redacción",
    "diagram": "Dibujo técnico, p.ej. diagrama de flujo o circuito",
    "sketch": "Boceto o ilustración libre",
    "gapText": "Rellenar huecos en un texto",
    "labelImage": "Etiquetar partes de una imagen o diagrama",
    "multipleChoice": "Seleccionar entre opciones dadas",
    "imageAnalysis": "Describir o analizar una imagen proporcionada",
    "mapping": "Conectar objetos o alternativas relacionados",
    "legalCase": "Análisis de caso jurídico (Gutachtenstil)",
    "calculation": "Cálculos matemáticos o físicos",
    "mathematicalProof": "Prueba matemática formal",
    "curveAnalysis": "Análisis de función (raíces, extremos, …)",
    "plotting": "Representar una función, gráfica o puntos en un sistema de coordenadas",
    "geometry": "Construcciones geométricas o cálculos (dibujo)",
    "programming": "Escribir o analizar código fuente",
    "art": "Crear una obra de arte o diseño artístico",
    "dictation": "Escribir texto dictado",
    "translation": "Traducir texto o palabras a otro idioma",
    "chemicalFormula": "Ecuaciones de reacción química o fórmulas",
    "music": "Leer o escribir notación musical",
    "literaryAnalysisPoetry": "Analizar un poema",
    "analysisNonFiction": "Analizar un texto no ficticio",
    "materialBasedEssay": "Escribir un ensayo basado en materiales proporcionados"
  },
  "TaskTypes": {
    "taskFrame": "Marco de la tarea",
    "default": "Predeterminado",
    "shortText": "Texto corto",
    "essay": "Ensayo",
    "diagram": "Diagrama",
    "sketch": "Boceto",
    "gapText": "Texto con huecos",
    "labelImage": "Etiquetar imagen",
    "multipleChoice": "Opción múltiple",
    "imageAnalysis": "Análisis de imagen",
    "mapping": "Correspondencia",
    "legalCase": "Caso jurídico",
    "calculation": "Cálculo",
    "mathematicalProof": "Demostración matemática",
    "curveAnalysis": "Análisis de funciones",
    "plotting": "Dibujo de gráficas",
    "geometry": "Geometría",
    "programming": "Programación",
    "art": "Arte",
    "dictation": "Dictado",
    "translation": "Traducción",
    "chemicalFormula": "Fórmula química",
    "music": "Música",
    "literaryAnalysisPoetry": "Análisis de poesía",
    "analysisNonFiction": "Análisis de texto no ficticio",
    "materialBasedEssay": "Ensayo basado en materiales"
  },
  "GapText": {
    "gap": "Hueco",
    "correct": "Correcto",
    "incorrect": "Incorrecto",
    "empty": "Vacío",
    "points": "Puntos",
    "expectedAnswer": "Respuesta esperada",
    "studentAnswer": "Respuesta del alumno",
    "status": "Estado"
  },
  "progress": {
    "analyzingSplit": "Analizando la división",
    "extractingAnswers": "Extrayendo respuestas de los estudiantes...",
    "errorExtractingAnswers": "Error al extraer respuestas de los estudiantes",
    "answersExtracted": "Respuestas de estudiantes extraídas",
    "extractingMasterSolution": "Extrayendo contenido de la solución modelo",
    "errorStructureMasterSolution": "Error al crear la estructura de la tarea (solución modelo)",
    "errorExtractingMasterSolution": "Error al extraer la solución modelo",
    "masterSolutionExtracted": "Solución modelo extraída",
    "extractingGradingScheme": "Extrayendo criterios de calificación",
    "errorStructureGradingScheme": "Error al crear la estructura de la tarea (criterios de calificación)",
    "errorExtractingGradingScheme": "Error al extraer los criterios de calificación",
    "gradingSchemeExtracted": "Criterios de calificación extraídos",
    "noUsableMasterSolution": "No se detectó contenido utilizable en la solución modelo. Por favor, revisa el archivo o ajusta la asignación.",
    "noUsableGradingScheme": "No se detectaron criterios de calificación utilizables. Por favor, revisa el archivo o ajusta la asignación.",
    "analyzingStructure": "Analizando estructura del examen",
    "noSubmissions": "No se encontraron entregas",
    "errorStructureAnalysis": "Error durante el análisis de la estructura del examen",
    "noTasksInStructure": "No se encontraron tareas en el análisis de la estructura",
    "extractingTaskDescriptions": "Extrayendo descripciones de tareas",
    "errorTaskDescriptions": "Error al extraer descripciones de tareas",
    "taskDescriptionsExtracted": "Descripciones de tareas extraídas",
    "taskStructureCreated": "Estructura de tareas creada",
    "waitingForStructureConfirmation": "Esperando a que el usuario confirme la estructura del examen",
    "structureConfirmed": "Estructura del examen confirmada",
    "structureConfirmationTimeout": "Tiempo de espera agotado para la confirmación de la estructura del examen",
    "errorWaitingStructureConfirmation": "Error al esperar la confirmación de la estructura del examen",
    "errorProcessingStructureConfirmation": "Error al procesar la confirmación de la estructura del examen",
    "errorCreatingTaskStructure": "Error al crear la estructura de tareas",
    "pipelineFailedPrematurely": "El proceso falló prematuramente",
    "assignmentConfirmed": "Asignación confirmada",
    "gradingRunning": "Corrección en curso...",
    "gradingTaskX": "Corrigiendo la tarea {{taskNumber}} ...",
    "gradingCompleted": "Corrección completada",
    "gradingTaskXCompleted": "Corrección de la tarea {{taskNumber}} completada"
  },
  "upload": {
    "noExamId": "No se encontró el ID del examen",
    "noFileSelected": "Ningún archivo seleccionado",
    "processingFailed": "El archivo no se pudo procesar",
    "invalidFileType": "Tipo de archivo no válido. Por favor, selecciona un archivo PNG o PDF.",
    "uploadError": "Error al subir el archivo",
    "studentName": "Estudiante {{index}}",
    "noExamIdForReupload": "Error: No hay ID de examen disponible para resubir.",
    "reuploadCancelled": "INFORMACIÓN DEL SISTEMA: Cancelación de subida procesada.",
    "reuploadCancelFailed": "INFORMACIÓN DEL SISTEMA: La cancelación de la subida no se pudo procesar completamente.",
    "filesMissing": "BLOQUEO DEL SISTEMA: Los siguientes archivos no se encontraron en la memoria de subida: {{files}}. Por favor, asegúrate de que los nombres de los archivos coincidan exactamente con los archivos subidos.",
    "assignmentMismatch": "BLOQUEO DEL SISTEMA: Las siguientes asignaciones de archivos no coinciden con la última propuesta. Por favor, llama a send_assignment_confirmation_message y confirma la nueva asignación con el usuario.\n{{lines}}",
    "reuploadStarted": "La resubida de archivos ha comenzado en segundo plano. {{extra}}",
    "splitStarted": "División de entregas de estudiantes iniciada.",
    "assignmentProposalSent": "Mensaje con propuesta de asignación enviado.",
    "assignmentConfirmationMessage": "No estoy del todo seguro acerca de la asignación de los archivos, dejaré que lo compruebes rápidamente.\n\nPor favor, confirma en el área de soltar y arrastrar que la asignación propuesta es correcta, o ajústala ahí mismo. Después, podré continuar de inmediato.",
    "assignmentProposalFallback": "Por favor, revisa mi propuesta de asignación y confirma el mapeo de archivos.",
    "categorySubmissions": "Entregas de los estudiantes",
    "categoryMasterSolution": "Solución modelo",
    "categoryGradingScheme": "Esquema de calificación",
    "categoryBlankExam": "Examen en blanco",
    "lowConfidenceListFormat": "'{{file}}' (planeado como {{category}})",
    "mismatchFormat": "- {{name}}: propuesto previamente como \"{{proposed}}\", ahora suministrado como \"{{supplied}}\""
  },
  "splitIssues": {
    "unknownStudent": "Estudiante desconocido",
    "studentNumber": "Estudiante {{number}}",
    "pageAssignmentError": "No todas las páginas fueron asignadas exactamente una vez",
    "nonConsecutive": "Páginas no consecutivas asignadas para {{names}} (Reordenado por el agente)",
    "uncertainty": "Incertidumbre con {{names}}",
    "outlierLongExtremeSingle": "La entrega de {{names}} es extremadamente larga",
    "outlierLongExtremePlural": "Las entregas de {{names}} son extremadamente largas",
    "outlierShortExtremeSingle": "La entrega de {{names}} es extremadamente corta",
    "outlierShortExtremePlural": "Las entregas de {{names}} son extremadamente cortas",
    "outlierLongSingle": "La entrega de {{names}} es inusualmente larga",
    "outlierLongPlural": "Las entregas de {{names}} son inusualmente largas",
    "outlierShortSingle": "La entrega de {{names}} es inusualmente corta",
    "outlierShortPlural": "Las entregas de {{names}} son inusualmente cortas",
    "missingStudentNameSingle": "No se pudo extraer un nombre para {{missingCount}} de {{totalCount}} estudiante",
    "missingStudentNamePlural": "No se pudo extraer un nombre para {{missingCount}} de {{totalCount}} estudiantes",
    "splitAgentFailure": "Error del agente de división{{suffix}}",
    "errorPrefix": "Error",
    "warningPrefix": "Advertencia",
    "parseErrorFallback": "No se pudieron procesar los datos. Revisa la asignación en el canvas.",
    "messageError": "He encontrado {{count}} estudiantes con {{range}} páginas cada uno, pero ocurrió un problema durante la asignación automática de páginas:\n{{problem}}\n\nPor favor, revisa la asignación en el Canvas de mapeo y corrígela manualmente si es necesario. Una vez que hayas terminado, por favor confirma en el chat o a través del botón para que podamos continuar.",
    "messageWarning": "He encontrado {{count}} estudiantes con {{range}} páginas cada uno, pero existen las siguientes notas:\n{{problem}}\n\nSi lo deseas, puedes revisar las notas en el Canvas de mapeo. De lo contrario, simplemente confirma para que podamos continuar.",
    "messageSuccess": "He encontrado {{count}} estudiantes con {{range}} páginas cada uno. La asignación fue clara. Se pudo extraer un nombre para todos los estudiantes. Por favor, confirma para que podamos continuar.",
    "confirmationRequested": "Confirmación de división solicitada",
    "splitAgentFailed": "La asignación automática de las entregas de los estudiantes falló. Por favor, intenta cargar el archivo nuevamente más tarde."
  },
  "structureIssues": {
    "pointsExplanation": "\n\n**Sobre los puntos:** He detectado puntos en algunas tareas. Si subes un esquema de evaluación con la puntuación (o ya lo has hecho), los puntos se tomarán de allí; entonces puedes ignorar los puntos del lienzo. Solo son relevantes si tu esquema de evaluación no los incluye o si quieres generar uno.\n\nReglas de puntuación: para cada tarea, asigna puntos a todas las subtareas directas de modo que sumen el total de la tarea superior, o a ninguna. Si no asignas puntos a las subtareas sino solo un total, la IA los distribuirá automáticamente al generar el esquema de evaluación.",
    "textCutoff": "Texto de la tarea incompleto",
    "missingInformation": "Falta información",
    "imageUnreadable": "Imagen ilegible",
    "task": "Tarea",
    "mainTasks_one": "He identificado {{mainCount}} tarea principal.",
    "mainTasks_other": "He identificado {{mainCount}} tareas principales.",
    "mainAndSubTasks_one": "He identificado {{mainCount}} tareas principales y {{subCount}} subtarea.",
    "mainAndSubTasks_other": "He identificado {{mainCount}} tareas principales y {{subCount}} subtareas.",
    "intro": "### He identificado la siguiente estructura de tareas:\n\n{{countText}}",
    "problemsIntro": "\n\nOcurrieron los siguientes problemas durante el reconocimiento de tareas: {{warnings}}. Por favor, comprueba las incertidumbres en el Canvas, edítalas si es necesario y luego confirma a través del botón o en el chat.",
    "uncertaintyIntro": "\n\nExisten incertidumbres respecto a {{labels}}. Por favor, comprueba las incertidumbres en el Canvas, edítalas si es necesario y luego confirma a través del botón o en el chat.",
    "success": "\n\nNo hubo problemas durante el reconocimiento de tareas. Si lo deseas, aún puedes revisarlas en el Canvas, de lo contrario, por favor confirma a través del botón o en el chat."
  },
  "chatMessages": {
    "emptyState": "Inicia una conversación escribiendo un mensaje abajo",
    "newMessage": "Nuevo mensaje",
    "cancel": "Cancelar",
    "send": "Enviar",
    "edit": "Editar",
    "editInCanvas": "Editar en el Canvas",
    "confirmed": "Confirmado",
    "confirm": "Confirmar",
    "confirmAssignment": "Confirmar asignación",
    "giveFeedback": "Dar opinión",
    "feedbackTitle": "Dar opinión",
    "feedbackDescription": "Haznos saber cómo podemos mejorar esta respuesta.",
    "feedbackPlaceholder": "Tu opinión aquí...",
    "feedbackSubmit": "Enviar opinión",
    "submitAssignmentConfirmation": "Confirmo la división de las páginas y la asignación a los estudiantes. Por favor, continúa.",
    "submitStructureConfirmation": "Confirmo la estructura de las tareas del examen.",
    "studentSubmissions": "Entregas de estudiantes",
    "masterSolution": "Solución modelo",
    "gradingScheme": "Esquema de calificación",
    "blankExam": "Examen en blanco",
    "confirmedAssignmentIntro": "La asignación de archivos confirmada:",
    "assignmentIntro": "He asignado los archivos de la siguiente manera. Por favor, revisa y confirma la asignación:"
  },
  "AuthModal": {
    "loginError": "Correo electrónico o contraseña incorrectos.",
    "signupFailed": "El registro ha fallado. Por favor, inténtalo de nuevo.",
    "passwordMismatch": "Las contraseñas no coinciden.",
    "forgotPasswordProblem": "Hubo un problema. Por favor, inténtalo de nuevo más tarde.",
    "waitlistTitle": "¡Estás en la lista!",
    "waitlistDesc": "Nos pondremos en contacto contigo en cuanto comience la siguiente fase.",
    "waitlistInactive": "Lista de espera actualmente desactivada.",
    "backToLogin": "Volver al inicio de sesión",
    "linkSentTitle": "¡Enlace enviado!",
    "linkSentDesc": "Entendido",
    "forgotPasswordTitle": "¿Olvidaste tu contraseña?",
    "requestLink": "Solicitar enlace",
    "welcomeBack": "Bienvenido de nuevo",
    "createAccount": "Crear una cuenta",
    "emailLabel": "Correo electrónico",
    "passwordLabel": "Contraseña",
    "forgotPasswordLink": "¿Olvidaste la contraseña?",
    "loginButton": "Iniciar sesión",
    "firstNameLabel": "Nombre",
    "lastNameLabel": "Apellidos",
    "schoolLabel": "Escuela",
    "subjectsLabel": "Asignaturas",
    "confirmPasswordLabel": "Confirmar",
    "signupButton": "Registrarse",
    "registerHere": "Regístrate aquí",
    "loginHere": "Inicia sesión aquí",
    "continueGuest": "Continuar sin iniciar sesión →"
  },
  "FeedbackPage": {
    "alerts": {
      "imageTooLarge": "La imagen \"{{name}}\" es demasiado grande (máx. 5MB).",
      "previewError": "No se pudo generar la vista previa de {{name}}.",
      "submitError": "Algo salió mal. Por favor, inténtalo de nuevo."
    },
    "success": {
      "title": "¡Gracias por tu feedback!",
      "description": "Hemos recibido tu mensaje. Tu aportación nos ayuda enormemente a mejorar Gradias cada día un poco más.",
      "backButton": "Volver al examen"
    },
    "header": {
      "title": "Dar feedback"
    },
    "content": {
      "description": "¿Has notado un error, tienes una idea genial o simplemente quieres decirnos algo? ¡Leemos todos los mensajes!"
    },
    "categories": {
      "title": "¿De qué se trata?",
      "bug": {
        "title": "Error / Bug",
        "desc": "Algo no funciona"
      },
      "feature": {
        "title": "Idea / Solicitud",
        "desc": "Una nueva función"
      },
      "general": {
        "title": "Otros",
        "desc": "Comentarios generales"
      }
    },
    "message": {
      "title": "Tu mensaje",
      "placeholder": "Describe tu solicitud lo más detalladamente posible..."
    },
    "upload": {
      "title": "Adjuntar captura de pantalla (Opcional)",
      "clickToSelect": "Haz clic para seleccionar imágenes",
      "formatConstraint": "PNG, JPG hasta un máx. de 5MB por imagen",
      "attachedImages": "Imágenes adjuntas",
      "removeImage": "Eliminar imagen"
    },
    "submit": {
      "sending": "Enviando...",
      "send": "Enviar feedback"
    }
  },
  "ConfirmationReplies": {
    "split": {
      "confirmed": "La asignación de estudiantes se ha confirmado correctamente. La extracción de la estructura de tareas puede continuar ahora. Agradece al usuario por confirmar la distribución y dile que la extracción empieza ahora.",
      "pending": "La asignación de estudiantes sigue pendiente de confirmación."
    },
    "structure": {
      "masterAndGrading": "La estructura de tareas se ha confirmado correctamente. La extracción continúa ahora en segundo plano. Ya se han subido una solución modelo y un esquema de evaluación, y se procesarán en segundo plano. Agradece brevemente al usuario por confirmar la estructura y dile que la extracción continúa. Sugiere iniciar la corrección.",
      "masterOnly": "La estructura de tareas se ha confirmado correctamente. La extracción continúa ahora en segundo plano. Ya se ha subido una solución modelo, pero aún falta el esquema de evaluación. Agradece brevemente al usuario por confirmar la estructura y dile que la extracción continúa. Sugiere generar ahora un esquema de evaluación basado en IA.",
      "gradingOnly": "La estructura de tareas se ha confirmado correctamente. La extracción continúa ahora en segundo plano. Ya se ha subido un esquema de evaluación, pero aún falta la solución modelo. Agradece brevemente al usuario por confirmar la estructura y dile que la extracción continúa. Sugiere generar ahora una solución modelo basada en IA.",
      "none": "La estructura de tareas se ha confirmado correctamente. La extracción continúa ahora en segundo plano. Todavía falta la solución modelo. Agradece brevemente al usuario por confirmar la estructura, indícale que la extracción continúa y pregúntale si quieres generar una solución modelo basada en IA cuando termine la extracción o si prefiere subir una solución propia con el clip del chat."
    },
    "errors": {
      "notConfirmed": "Confirmation flag is false; nothing to do.",
      "missingIdentifiers": "Missing required identifiers for confirmation.",
      "missingSplitMessage": "Error: no se encontró un mensaje de confirmación de división asignado.",
      "missingStructureMessage": "Error: no se encontró un mensaje de confirmación de estructura asignado.",
      "structureContentMissing": "Error: no se pudo cargar el mensaje de confirmación de estructura.",
      "splitFailure": "Error al confirmar la división.",
      "structureFailure": "Error al confirmar la estructura."
    }
  },
  "toolFallbackDesc": {
    "default": "Ejecutar paso herramienta",
    "set_metadata": "Establecer metadatos",
    "create_exam": "Crear el examen ahora",
    "generate_master_solution": "Generar solucion modelo",
    "refine_master_solution": "Refinar solucion modelo",
    "generate_grading_scheme": "Generar esquema evaluacion",
    "refine_grading_scheme": "Refinar esquema evaluacion",
    "run_grading_agent": "Ejecutar agente evaluacion",
    "set_task_score": "Establecer puntuacion manualmente",
    "open_canvas": "Abrir vista canvas",
    "update_open_task_content": "Actualizar tarea abierta",
    "send_assignment_confirmation_message": "Solicitar confirmacion asignacion",
    "process_files": "Procesar archivos subidos",
    "confirm_split_in_chat": "Confirmar separacion chat",
    "confirm_structure_in_chat": "Confirmar estructura chat",
    "query_exams": "Consultar examenes",
    "query_submissions": "Consultar entregas",
    "get_available_options": "Obtener opciones disponibles",
    "get_task_types": "Obtener tipos de tareas",
    "download_ms_gs": "Descargar solución modelo y esquema",
    "download_summary_reports": "Descargar informes de resumen",
    "save_teacher_memory": "Recordar preferencia",
    "get_teacher_memory": "Consultar preferencias",
    "delete_teacher_memory": "Eliminar preferencias",
    "reprocess_errored_submissions": "Reprocesar entregas con errores"
  },
  "Subjects": {
    "math": "Matemáticas",
    "physics": "Física",
    "chemistry": "Química",
    "biology": "Biología",
    "history": "Historia",
    "geography": "Geografía",
    "english": "Inglés",
    "german": "Alemán",
    "french": "Francés",
    "spanish": "Español",
    "computer_science": "Informática",
    "social_studies": "Ciencias Sociales",
    "other": "Otra"
  },
  "ExamNotifications": {
    "newMessage": "Nuevo Mensaje"
  },
  "LanguageUseTemplates": {
    "essay": "Niveles de rendimiento · Desempeño en la presentación\n\n* sobresaliente:\n  - El texto está estructurado de forma clara y lógica, con conexiones eficaces entre las secciones.\n  - El lenguaje especializado se emplea con seguridad y precisión.\n  - Las citas están integradas correctamente e introducidas en su contexto; las referencias incluyen el número de línea.\n  - La sintaxis es variada, estilísticamente segura y adecuada al objeto literario.\n  - La gramática, la ortografía y la puntuación son casi impecables.\n* bien:\n  - El texto está estructurado de forma coherente.\n  - El lenguaje especializado se emplea mayormente con seguridad.\n  - Las citas se utilizan de forma adecuada y están correctamente referenciadas.\n  - La sintaxis es correcta y variada.\n  - Pocas infracciones de gramática, ortografía y puntuación.\n* satisfactorio:\n  - La estructura es reconocible, pero no es coherente en todo momento.\n  - El lenguaje especializado se emplea de forma funcional, pero no siempre con precisión.\n  - Se utilizan citas, y las referencias son mayormente correctas.\n  - La sintaxis es mayormente correcta, en ocasiones monótona.\n  - Las infracciones de gramática, ortografía y puntuación no dificultan la comprensión.\n* suficiente:\n  - La estructura es reconocible solo de forma rudimentaria.\n  - El lenguaje especializado se emplea solo parcialmente o de forma imprecisa.\n  - Las citas son inconsistentes o están referenciadas de forma incompleta.\n  - La sintaxis es uniforme, con inseguridades frecuentes.\n  - La corrección lingüística es limitada; la comprensión se ve dificultada ocasionalmente.\n* deficiente:\n  - La presentación es, en gran medida, poco estructurada.\n  - El lenguaje especializado falta en gran medida o se emplea incorrectamente.\n  - Las citas faltan o son incorrectas.\n  - Las deficiencias lingüísticas dificultan considerablemente la comprensión.\n* insuficiente:\n  - La presentación es tan deficiente que el trabajo apenas resulta comprensible.\n  - No se reconocen los requisitos básicos de un ensayo de interpretación literaria escrito.",
    "analysisNonFiction": "Niveles de rendimiento · Desempeño en la presentación\n\n* sobresaliente:\n  - El texto está estructurado de forma clara y lógica, con conexiones eficaces entre las secciones.\n  - El lenguaje especializado se emplea con seguridad y precisión.\n  - Las citas están integradas correctamente e introducidas en su contexto; las referencias incluyen el número de línea.\n  - La sintaxis es variada, estilísticamente segura y adecuada al objeto literario.\n  - La gramática, la ortografía y la puntuación son casi impecables.\n* bien:\n  - El texto está estructurado de forma coherente.\n  - El lenguaje especializado se emplea mayormente con seguridad.\n  - Las citas se utilizan de forma adecuada y están correctamente referenciadas.\n  - La sintaxis es correcta y variada.\n  - Pocas infracciones de gramática, ortografía y puntuación.\n* satisfactorio:\n  - La estructura es reconocible, pero no es coherente en todo momento.\n  - El lenguaje especializado se emplea de forma funcional, pero no siempre con precisión.\n  - Se utilizan citas, y las referencias son mayormente correctas.\n  - La sintaxis es mayormente correcta, en ocasiones monótona.\n  - Las infracciones de gramática, ortografía y puntuación no dificultan la comprensión.\n* suficiente:\n  - La estructura es reconocible solo de forma rudimentaria.\n  - El lenguaje especializado se emplea solo parcialmente o de forma imprecisa.\n  - Las citas son inconsistentes o están referenciadas de forma incompleta.\n  - La sintaxis es uniforme, con inseguridades frecuentes.\n  - La corrección lingüística es limitada; la comprensión se ve dificultada ocasionalmente.\n* deficiente:\n  - La presentación es, en gran medida, poco estructurada.\n  - El lenguaje especializado falta en gran medida o se emplea incorrectamente.\n  - Las citas faltan o son incorrectas.\n  - Las deficiencias lingüísticas dificultan considerablemente la comprensión.\n* insuficiente:\n  - La presentación es tan deficiente que el trabajo apenas resulta comprensible.\n  - No se reconocen los requisitos básicos de un ensayo de interpretación literaria escrito.",
    "genericGroup": "Niveles de rendimiento · Desempeño en la presentación\n\n* sobresaliente:\n  - El texto está estructurado de forma clara y lógica, con conexiones eficaces entre las secciones.\n  - El lenguaje especializado se emplea con seguridad y precisión.\n  - Las citas están integradas correctamente e introducidas en su contexto; las referencias incluyen el número de línea.\n  - La sintaxis es variada, estilísticamente segura y adecuada al objeto literario.\n  - La gramática, la ortografía y la puntuación son casi impecables.\n* bien:\n  - El texto está estructurado de forma coherente.\n  - El lenguaje especializado se emplea mayormente con seguridad.\n  - Las citas se utilizan de forma adecuada y están correctamente referenciadas.\n  - La sintaxis es correcta y variada.\n  - Pocas infracciones de gramática, ortografía y puntuación.\n* satisfactorio:\n  - La estructura es reconocible, pero no es coherente en todo momento.\n  - El lenguaje especializado se emplea de forma funcional, pero no siempre con precisión.\n  - Se utilizan citas, y las referencias son mayormente correctas.\n  - La sintaxis es mayormente correcta, en ocasiones monótona.\n  - Las infracciones de gramática, ortografía y puntuación no dificultan la comprensión.\n* suficiente:\n  - La estructura es reconocible solo de forma rudimentaria.\n  - El lenguaje especializado se emplea solo parcialmente o de forma imprecisa.\n  - Las citas son inconsistentes o están referenciadas de forma incompleta.\n  - La sintaxis es uniforme, con inseguridades frecuentes.\n  - La corrección lingüística es limitada; la comprensión se ve dificultada ocasionalmente.\n* deficiente:\n  - La presentación es, en gran medida, poco estructurada.\n  - El lenguaje especializado falta en gran medida o se emplea incorrectamente.\n  - Las citas faltan o son incorrectas.\n  - Las deficiencias lingüísticas dificultan considerablemente la comprensión.\n* insuficiente:\n  - La presentación es tan deficiente que el trabajo apenas resulta comprensible.\n  - No se reconocen los requisitos básicos de un ensayo de interpretación literaria escrito.",
    "materialBasedEssay": "Escritura a partir de materiales (redacción de textos argumentativos / informativos)\n\nDesempeño de contenido y uso de los materiales (comprensión / estructura textual):\n* La introducción es breve, despierta el interés del lector y conduce al tema (se evitan las transiciones tópicas).\n* Se reconoce una estructura coherente que corresponde a todos los componentes del tipo de texto exigido (p. ej., comentario, ensayo, artículo).\n* El tema y la problemática correspondiente se delimitan claramente al principio.\n* Los conceptos básicos importantes se explican adecuadamente cuando es necesario.\n* Todos los materiales proporcionados se tienen en cuenta y se integran en el texto de forma sensata y con corrección de contenido.\n* Existe transparencia en las afirmaciones ajenas (citas correctas, paráfrasis y referencia a las fuentes).\n* Se distingue claramente entre la exposición de los hechos, la argumentación y la valoración propia.\n* La argumentación es amplia y diferenciada (tiene en cuenta diversos aspectos del tema, así como posibles contraargumentos).\n* Los argumentos individuales resultan convincentes para el público destinatario, están claramente estructurados, explicados y respaldados con pruebas/ejemplos.\n* Además de los argumentos de los materiales, se aportan argumentos propios y conocimientos especializados propios.\n* La argumentación se recoge al final en una conclusión, a la que puede seguir una perspectiva de futuro.\n\nDesempeño lingüístico y configuración textual (desempeño en la presentación):\n* La configuración lingüística corresponde al tipo de texto exigido, con un lenguaje claro y preciso y formulaciones propias.\n* El vocabulario, el dominio de los términos especializados y el estilo funcional son precisos, diferenciados y estilísticamente adecuados.\n* La construcción de las frases es manejable, variada y gramaticalmente compleja.\n* Los errores normativos (de gramática, ortografía y puntuación) no dificultan la fluidez de la lectura.",
    "literaryAnalysisPoetry": "Desempeño en la presentación\n* 1. El examinando estructura su texto de forma coherente, lógica, consistente y con claridad de pensamiento:\n  - ponderación adecuada de las subtareas en la ejecución\n  - disposición estructurada y adecuadamente ponderada del trabajo\n  - conexión coherente entre los distintos pasos de trabajo\n  - conexión de pensamiento coherente entre las frases\n* 2. El examinando formula sus ideas respetando los requisitos del lenguaje especializado y metodológico propios de la asignatura:\n  - separación entre el nivel de la acción y el metanivel\n  - relación fundamentada entre afirmaciones descriptivas, interpretativas y valorativas\n  - uso de terminología especializada en un contexto pertinente\n  - observancia de los tiempos verbales\n  - reproducción correcta del discurso referido (modalidad)\n* 3. El examinando fundamenta sus afirmaciones mediante citas adecuadas y correctas:\n  - uso sensato de citas completas o abreviadas con función argumentativa\n* 4. El examinando se expresa con precisión lingüística general, seguridad estilística y diferenciación conceptual:\n  - un estilo de escritura objetivo y distanciado\n  - un registro propio de la lengua escrita\n  - capacidad de expresión conceptual y abstracta\n* 5. El examinando formula con seguridad léxica y sintáctica, de forma variada y compleja (y, al mismo tiempo, clara).\n* 6. El examinando escribe con corrección lingüística."
  },
  "LatexEditor": {
    "insertFormula": "Fórmula",
    "insertFormulaHint": "Insertar una nueva fórmula en la posición del cursor",
    "switchToRawLatex": "Cambiar a LaTeX sin procesar",
    "switchToVisualEditor": "Cambiar al editor visual",
    "naturalLanguageHint": "Describe esta fórmula en lenguaje natural",
    "naturalLanguagePlaceholder": "p. ej. «integral de 0 a 10 de x²»",
    "naturalLanguageError": "Error en la traducción. Inténtalo de nuevo.",
    "insert": "Insertar",
    "removeFormula": "Eliminar fórmula",
    "cancel": "Cancelar"
  },
  "StudentExam": {
    "loading": "Cargando el examen…",
    "examFallbackTitle": "Examen",
    "classLabel": "Clase {{class}}",
    "namePlaceholder": "Tu nombre",
    "answeredCount": "{{answered}} / {{total}} respondidas",
    "submit": "Entregar",
    "signInRequiredTitle": "Inicio de sesión necesario",
    "signInRequiredBody": "Inicia sesión para resolver este examen.",
    "signInAction": "Ir al inicio de sesión",
    "unavailableTitle": "No disponible",
    "submittedTitle": "Entregado",
    "submittedBody": "Tus respuestas se han guardado y están listas para la corrección.",
    "errors": {
      "loadFailed": "No se ha podido cargar el examen.",
      "notFound": "Este examen no existe.",
      "notSignedIn": "No has iniciado sesión.",
      "noAccess": "Examen no encontrado o sin acceso.",
      "noTasks": "Este examen todavía no tiene tareas.",
      "uploadedExam": "Este examen se subió en lugar de crearse, por lo que no se puede rellenar en línea.",
      "studentsOnly": "Completar esto en línea solo está disponible para cuentas de estudiante.",
      "renderFailed": "No se ha podido mostrar el examen.",
      "unreadableAnswers": "No se han podido leer las respuestas.",
      "submitFailed": "Error al entregar."
    },
    "canvas": {
      "undo": "Deshacer",
      "clear": "Borrar",
      "pen": "Lápiz",
      "eraser": "Borrador",
      "redo": "Rehacer",
      "zoom": "Dibujar ampliado",
      "zoomClose": "Cerrar vista ampliada",
      "penWidth": "Grosor {{width}}"
    }
  }
}
